// src/pages/YearsPage.tsx

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { isAdmin } from '../utils/adminUtils';

export function YearsPage() {
  const navigate = useNavigate();
  const years = useAppStore((s) => s.years);
  const isLoading = useAppStore((s) => s.isLoading);
  const error = useAppStore((s) => s.error);
  const fetchYears = useAppStore((s) => s.fetchYears);
  const refresh = useAppStore((s) => s.refresh);
  const session = useAppStore((s) => s.session);
  const showAdminButton = session?.idToken && isAdmin(session.idToken);

  useEffect(() => {
    if (years.length === 0) {
      fetchYears();
    }
  }, [years.length, fetchYears]);

  if (isLoading) {
    return (
      <div className="years-page" role="status" aria-label="Loading years">
        <div className="loading-indicator">Loading…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="years-page">
        <div className="error-state" role="alert">
          <p>{error}</p>
          <button
            className="retry-button"
            onClick={() => fetchYears()}
            style={{ minHeight: '44px' }}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (years.length === 0) {
    return (
      <div className="years-page">
        <p className="empty-state">No albums available</p>
      </div>
    );
  }

  return (
    <div className="years-page">
      <div className="years-header">
        <h1>Albums</h1>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {showAdminButton && (
            <button
              className="refresh-button"
              onClick={() => navigate('/admin')}
              aria-label="Admin panel"
              style={{ minHeight: '44px' }}
            >
              ⚙️ Admin
            </button>
          )}
          <button
            className="refresh-button"
            onClick={() => navigate('/search')}
            aria-label="Search events"
            style={{ minHeight: '44px' }}
          >
            🔍 Search
          </button>
          <button
            className="refresh-button"
            onClick={() => refresh()}
            aria-label="Refresh albums"
            style={{ minHeight: '44px' }}
          >
            Refresh
          </button>
        </div>
      </div>
      <ul className="years-list" role="list">
        {years.map((year) => (
          <li key={year.name}>
            <button
              className="year-card"
              onClick={() => navigate(`/years/${year.name}`)}
              aria-label={`${year.name}, ${year.eventCount} events`}
              style={{ minHeight: '44px', width: '100%' }}
            >
              <span className="year-name">📅 {year.name}</span>
              <span className="year-event-count">
                ({year.eventCount})
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
